import { api as apiProvider, apiMipe } from '@/core/api/';

export const getDocumentTypes = async () => {
  return apiMipe.get('api/documents/documenttypes', {
    params: { codeType: 'BecaCardHandling' },
  });
};

export const uploadDocument = (document) => {
  return apiProvider.post('api/beca/card/evidencedocument', document, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
